"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaywallAdapter = void 0;
const demarked_1 = require("@d24/demarked");
const _contracts_1 = require("../_contracts");
const adapter_1 = require("../_helpers/adapter");
/**
 * @author Adrian Gajos <adrian.gajos@movecloser.pl>
 */
class PaywallAdapter {
    /**
     * @inheritDoc
     */
    objectToToken() {
        return {
            content: '#PAYWALL',
            raw: '#PAYWALL',
            type: demarked_1.TokenType.Paywall
        };
    }
    /**
     * @inheritDoc
     */
    tokenToObject() {
        return {
            ...adapter_1.getModuleBase(),
            content: {},
            driver: _contracts_1.ModuleDriver.Paywall
        };
    }
}
exports.PaywallAdapter = PaywallAdapter;
//# sourceMappingURL=Paywall.adapter.js.map